import { Component, OnInit, inject, input, ChangeDetectionStrategy } from '@angular/core';
import {LoadingService} from '../services/loading.service';
import {RouteConfigLoadEnd, RouteConfigLoadStart, Router} from '@angular/router';
import {map} from 'rxjs/operators';
import { NgStyle } from '@angular/common';
import { UrlBuilderService } from '../../services/url-builder.service';
import { Store } from '@ngrx/store';
import { AppState } from '../../store';
import { selectTenantInfo } from '../../store/selectors';
import { toSignal } from '@angular/core/rxjs-interop';

@Component({
    selector: 'loading',
    templateUrl: './loading.component.html',
    styleUrls: ['./loading.component.scss'],
  imports: [NgStyle],
  changeDetection:ChangeDetectionStrategy.OnPush
})
export class LoadingComponent implements OnInit {
  private loadingService = inject(LoadingService);
  private router = inject(Router);
  private ub = inject(UrlBuilderService);
  private store = inject<Store<AppState>>(Store);

  readonly detectLazyLoading = input(false);
  readonly loadingSignal = this.loadingService.loadingSignal;
  readonly spinnerUrl = this.ub.buildImageUrl('loader/loading-indicator-not-used.svg');

  readonly brandPrimaryColor = toSignal(
    this.store.select(selectTenantInfo).pipe(
      map(tenant => tenant?.brandTheme?.primaryColor || '#2D405D')
    ),
    { initialValue: '#2D405D' }
  );

  ngOnInit() {
    if (this.detectLazyLoading()) {
      this.router.events.subscribe(event => {
        if (event instanceof RouteConfigLoadStart) {
          this.loadingService.loadingOn();
        } else if (event instanceof RouteConfigLoadEnd) {
          this.loadingService.loadingOff();
        }
      });}
  }

}
